import { LayoutList, Map } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import Path from '../../Path';
import { useLanguage } from '../../i18n/useLanguage';
import { buttonClassName } from '../components/Button';

import type { LayoutVariant } from './layoutTypes';

/**
 * Petit bouton qui bascule entre la vue carte (par défaut) et la vue standard. C'est un lien :
 * chaque vue a sa propre URL (partageable, bouton "retour" du navigateur).
 */
export default function ViewSwitch({ variant }: { variant: LayoutVariant }) {
    const { t } = useTranslation();
    const { localize } = useLanguage();

    const isMap = variant === 'map';
    const Icon = isMap ? LayoutList : Map;

    return (
        <Link
            to={localize(isMap ? Path.EXEMPLE_HOME : Path.MAP)}
            title={t('layout.viewSwitch.label')}
            className={buttonClassName('secondary', 'px-2.5 py-1.5 text-xs')}
        >
            <Icon aria-hidden="true" className="size-4 shrink-0" />
            <span className="max-sm:sr-only">
                {t(isMap ? 'layout.viewSwitch.toStandard' : 'layout.viewSwitch.toMap')}
            </span>
        </Link>
    );
}
